import React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { userService } from '../../../../core/services'
import * as constants from '../../../../static/constants'
import { Button, InputText, Select } from '../../../atoms'
import { Form } from '../../../molecules'

const FIELDS = {
  email: 'email',
  user_type: 'user_type',
}

export const USER_TYPE = [
  { id: 'guest', label: 'Login as guest' },
  { id: 'guide', label: 'Login as guide' },
  { id: 'agent', label: 'Login as agent' },
  { id: 'administrator', label: 'Login as admin' },
]

interface IState {
  email: string
  errors: any
}

class UserPasswordsNew extends React.Component<{}, IState> {
  constructor(props) {
    super(props)
    this.state = {
      email: null,
      errors: {},
    }
  }

  public handleUpdateForm = (errors, hasNoError) => {
    this.setState({
      errors: {
        ...this.state.errors,
        ...errors,
      },
    })
  }

  public handleSubmit = async (initialValues, values) => {
    const { redirectUrl } = await userService.createPasswordResetInstruction({ user: values })

    location.href = redirectUrl
  }

  public render() {
    return (
      <UserPasswordsNewWrapper>
        <Panel>
          <Form
            fields={FIELDS}
            handleSubmit={this.handleSubmit}
            handleUpdateForm={this.handleUpdateForm}
          >
            <FormItem>
              <InputText
                required={true}
                name="email"
                defaultValue=""
                label={I18n.t('generic.email')}
                placeholder="Email"
                error={this.state.errors.email}
              />
            </FormItem>
            <FormItem>
              <Select
                required={true}
                label="User Type"
                name="user_type"
                options={USER_TYPE.map(user_type => ({
                  value: user_type.id,
                  label: user_type.label,
                }))}
                defaultValue={USER_TYPE[0].label}
              />
            </FormItem>
            <Buttons>
              {this.state.errors.login && <span className="error">{this.state.errors.login}</span>}
              <Button primary={true} backgroundColor={'#FF923E'}>
                {I18n.t('generic.send')}
              </Button>
              <p>
                <a href="/users/sign_up">{I18n.t('session.signup_page_for_guest')}</a>
              </p>
            </Buttons>
          </Form>
        </Panel>
      </UserPasswordsNewWrapper>
    )
  }
}

const UserPasswordsNewWrapper = styled.main`
  padding-top: 36px;

  .error {
    color: ${constants.COLORS.cautionText};
    display: block;
    margin-bottom: 12px;
  }
`

const Buttons = styled.div`
  margin-top: 24px;
  text-align: center;

  > p {
    display: block;
    margin: 16px auto 0;

    a {
      color: ${constants.COLORS.primary};
      text-decoration: underline;
    }
  }

  .Button {
    display: block;
    margin: 0 auto;
    width: 160px;
    height: 40px;
    font-weight: bold;
    font-size: 16px;
  }
`

const Panel = styled.div`
  background-color: ${constants.COLORS.white};
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(21, 27, 38, 0.15);
  max-width: 600px;
  margin: 0 auto;
  padding: 24px;
`

const FormItem = styled.div`
  & + & {
    margin-top: 16px;
  }
`

export default UserPasswordsNew
